import { RateSubscription } from "./RateSubscription";

export enum RateSubscriptionEventType {
  SUBSCRIBE,
  UNSUBSCRIBE,
}

export class RateSubscriptionEvent {
  constructor(public rateSubscription: RateSubscription, public type: RateSubscriptionEventType) {}
}
